import Image, { StaticImageData } from 'next/image';
import { ReactNode } from 'react';
import { FlagIcon, UsersIcon } from '@heroicons/react/outline';
import { MegaphoneIcon } from '@jove-frontend/uikit';
import PartnershipThumbnail from '../../assets/blog_thumbnail_blue.jpg';
import HelpThumbnail from '../../assets/blog_thumbnail_green.jpg';
import FeatureThumbnail from '../../assets/blog_thumbnail_red.jpg';
import { BlogPost, Category } from '../../lib/blog';

export const getThumbnail = (category: Category): string | StaticImageData => {
  switch (category) {
    case Category.Feature:
      return FeatureThumbnail;
    case Category.Partnerships:
      return PartnershipThumbnail;
    case Category.Help:
      return HelpThumbnail;
    default:
      return FeatureThumbnail;
  }
};

export const getIcon = (category: Category): ReactNode => {
  switch (category) {
    case Category.Feature:
      return <MegaphoneIcon className="h-full w-full text-white" />;
    case Category.Partnerships:
      return <UsersIcon className="h-full w-full text-white" strokeWidth={1} />;
    case Category.Help:
      return <FlagIcon className="h-full w-full text-white" strokeWidth={1} />;
    default:
      return null;
  }
};

type Props = {
  post: BlogPost;
};

export const BlogPostThumbnail = ({ post }: Props) => {
  const { thumbnail, category } = post;
  const src = thumbnail?.url;

  return (
    <div className="thumbnail">
      {src && (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={src}
          alt="Post thumbnail"
          className="h-full w-full object-cover object-center transition-transform duration-300 ease-linear hover:scale-105"
        />
      )}

      {!src && (
        <>
          <Image
            src={getThumbnail(category)}
            alt="Thumbnail"
            fill={true}
            style={{ objectFit: 'cover' }}
          />
          <div className="icon absolute left-1/2 top-1/2 h-24 w-24 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white p-5">
            {getIcon(category)}
          </div>
        </>
      )}
    </div>
  );
};
